App.filter('ellipsis', function() {
  return function(input, total) {
    if(!input){ return input; }
    if (input.length > total) {
      return (input.slice(0, total) + "...");
    }
    return (input);
  }
});